import { DesignToken } from "@microsoft/fast-foundation";
/** @internal */
export const { create } = DesignToken;
/** @internal */
export function createNonCss(name) {
    return DesignToken.create({ name, cssCustomPropertyName: null });
}
